export default {
  name: "Other Material Terms and Conditions of the Job Offer",
  prefix: "F.b-c",
  sections: [
    {
      name: "Daily Transportation",
      fields: [
        {
          isGroup: {
            code: "F.d.1",
            machine_name: "recIsDailyTransport",
            label:
              "Workers will be provided with daily transportation to and from the worksite in compliance with all applicable Federal, State and local laws and regulations. *",
            tooltip:
              "Indicate whether workers will be provided with daily transportation to and from the worksite in compliance with all applicable Federal, State, and local laws and regulations by marking “Yes” or “N/A.”",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "On-the-Job Training Available",
      fields: [
        {
          isGroup: {
            code: "F.d.2",
            machine_name: "recIsTrainingAvailable",
            label:
              "Workers will be provided with on-the-job training to perform the duties assigned. *",
            tooltip:
              "Indicate whether workers will be provided with on-the-job training to perform the duties assigned by marking “Yes” or “N/A.”",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Employer-Provided Tools and Equipment",
      fields: [
        {
          isGroup: {
            code: "F.d.3",
            machine_name: "recIsToolsEquip",
            label:
              "Workers will be provided, without charge or deposit charge, all tools, supplies, and equipment required to perform the duties assigned. *",
            tooltip:
              "Indicate whether workers will be provided, without charge or deposit charge, all tools, supplies, and equipment required to perform the duties assigned by marking “Yes” or “N/A.”",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
              },
            ],
            warning: {
              text: "The employer must provide to the worker, without charge or deposit charge, all tools, supplies, and equipment required to perform the duties assigned",
              isVisible: {
                when: "recIsToolsEquip",
                is: "N/A",
              },
            },
          },
        },
      ],
    },
    {
      name: "Board, Lodging, or Other Facilities",
      fields: [
        {
          isGroup: {
            code: "F.d.4",
            machine_name: "recIsLodging",
            label:
              "Workers will be provided with board, lodging, or other facilities and/or the employer will assist workers in securing board, lodging, or other facilities. *",
            tooltip:
              "Indicate whether workers will be provided with board, lodging, or other facilities and/or the employer will assist workers in securing board, lodging, or other facilities by marking “Yes” or “N/A.”",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Deduction From Pay",
      fields: [
        {
          code: "F.d.5",
          machine_name: "recPayDeductions",
          label:
            "State all deduction(s) from pay and, if known, the amount(s).",
          tooltip:
            "State all deduction(s) from pay not required by law and, if known, the amount(s). If no deductions other than those required by law will be made from the workers’ pay, enter “None” in the space provided.",
          widget: "text_area",
          validate: ["required"],
          inputLimit: 1000,
          width: 8,
          rows: 8,
        },
      ],
    },
  ],
};
